<ng-container *ngIf="isReadonly; then readonlyContent; else editableContent"></ng-container>

<ng-template #readonlyContent>
  <div [class]="cssClass">
    <div class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">
          {{ 'Conversation::QueryBuilder:NonFcrStatus' | abpLocalization }}
        </label>
      </div>
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">{{ payload.operator | operator }}</label>
      </div>
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">
          {{ 'GenericLookup::' + currentNonFcrStatus | abpLocalization }}
        </label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editableContent>
  <div [class]="cssClass">
    <div showButtonsOnHover class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">
          {{ 'Conversation::QueryBuilder:NonFcrStatus' | abpLocalization }}
        </label>
      </div>
      <div class="col-auto">
        <select class="form-select form-select-sm" [(ngModel)]="payload.operator">
          <option *ngFor="let operator of node.categoryItem.operators" [value]="operator">
            {{ operator | operator }}
          </option>
        </select>
      </div>
      <div class="col-auto">
        <select
          class="form-select form-select-sm"
          [(ngModel)]="payload.value"
          (ngModelChange)="valueChanged()">
          <option *ngFor="let nonFcrStatus of nonFcrStatuses$ | async" [value]="nonFcrStatus.id">
            {{ 'GenericLookup::' + nonFcrStatus.code | abpLocalization }}
          </option>
        </select>
      </div>
      <div style="gap: 8px" class="col-auto d-flex flex-row justify-content-center">
        <ca-query-builder-node-duplicate-button
          (buttonClick)="onClickDuplicate($event)"></ca-query-builder-node-duplicate-button>
        <ca-query-builder-node-remove-button
          (buttonClick)="removeNode($event)"></ca-query-builder-node-remove-button>
      </div>
    </div>
  </div>
</ng-template>
